<mat-toolbar color="primary">
  <a mat-button routerLink="/" class="app-title">Cordell Identity</a>
  <span class="spacer"></span>
  @if (isLoggedIn) {
    <button mat-button (click)="logout()">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  }
</mat-toolbar>
<main class="content">
  <router-outlet></router-outlet>
</main>
